export default [{
  path: '/authManage',
  name: 'authManage',
  component: () => import('@/pages/authManage/index'),
  meta: {
    pageId: 10005,
    spm: 2273,
  },
}];
